require('./bootstrap');
require('./services/server_responses');

import Vue from 'vue';
window.EventHandler = new Vue;
import VueRouter from 'vue-router';
import store from './store';

import Vuelidate from 'vuelidate';
import VueMask from 'v-mask';


import { BreadcrumbPlugin, ModalPlugin, SpinnerPlugin, FormRatingPlugin, PopoverPlugin } from 'bootstrap-vue';
import Swal from 'sweetalert2';
window.Swal = Swal;
Vue.use(BreadcrumbPlugin);
Vue.use(ModalPlugin);
Vue.use(SpinnerPlugin);
Vue.use(FormRatingPlugin);
Vue.use(PopoverPlugin);

Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueMask);


require('./components');

import router from './routes.js';

new Vue({
    router, store,

    created() {
        this.$store.dispatch('fetchCategories');
        // this.$store.dispatch('fetchBrands');
        this.$store.dispatch('fetchUser');
    }
}).$mount('#app');
